import { useQuery } from '@tanstack/react-query';

import VendorsService from '~/services/VendorsService';

export const propertyParityQueryKeys = {
  all: ['propertyParity'] as const,
  byOffer: (offerId: string) => [...propertyParityQueryKeys.all, offerId] as const,
};

export function usePropertyParity(offerId: string | null) {
  return useQuery({
    queryKey: propertyParityQueryKeys.byOffer(offerId ?? ''),
    queryFn: () => VendorsService.getParity(offerId, 'value'),
    select: (response) => response.data,
    enabled: !!offerId,
  });
}
